export default [
    {
        path: '/pages/plateform/InformationView',
        name: '/pages/plateform/InformationView',
        component: () => import('@/views/plateform/InformationView.vue')
    },
    {
        path: '/pages/plateform/PersonalCenter',
        name: '/pages/plateform/PersonalCenter',
        component: () => import('@/views/plateform/PersonalCenter.vue')
    },
    {
        path: '/pages/plateform/personalInfo',
        name: '/pages/plateform/personalInfo',
        component: () => import('@/views/plateform/personalInfo.vue')
    },
    {
        path: '/pages/plateform/websiteAccessLogManage',
        name: '/pages/plateform/websiteAccessLogManage',
        component: () => import('@/views/plateform/websiteAccessLogManage.vue')
    },
    {
        path: '/pages/plateform/homePage',
        name: '/pages/plateform/homePage',
        component: () => import('@/views/plateform/homePage.vue')
    },
    {
        path: '/pages/plateform/payResult',
        name: '/pages/plateform/payResult',
        component: () => import('@/views/plateform/payResult.vue')
    },
    {
        path: '/pages/plateform/product',
        name: '/pages/plateform/product',
        component: () => import('@/views/plateform/product.vue')
    },
    {
        path: '/pages/plateform/productDetail',
        name: '/pages/plateform/productDetail',
        component: () => import('@/views/plateform/productDetail.vue')
    },
    {
        path: '/pages/plateform/Register',
        name: '/pages/plateform/Register',
        component: () => import('@/views/plateform/Register.vue')
    },
    {
        path: '/pages/plateform/Address',
        name: '/pages/plateform/Address',
        component: () => import('@/views/plateform/Address.vue')
    },
    {
        path: '/pages/plateform/CartView',
        name: '/pages/plateform/CartView',
        component: () => import('@/views/plateform/CartView.vue')
    },
    {
        path: '/pages/plateform/login',
        name: '/pages/plateform/login',
        component: () => import('@/views/plateform/login.vue')
    },
    {
        path: '/pages/plateform/Order',
        name: '/pages/plateform/Order',
        component: () => import('@/views/plateform/Order.vue')
    },
    {
        path: '/pages/plateform/Pay',
        name: '/pages/plateform/Pay',
        component: () => import('@/views/plateform/Pay.vue')
    }
]